import { map } from 'lodash'

const allergenIncludedIngredientsDetailsFormInitialValues =
  includedIngredients => ({
    allergenIncludedIngredientIds: map(includedIngredients, 'id'),
  })

export default allergenIncludedIngredientsDetailsFormInitialValues
